<template>
  <div class="position">
    <template v-if="Number(gender) == 1">
      <div class="item left">
        <img
          class="bg"
          src="@/assets/imgs/actPosition/normal/men-zm/man-zm.png"
          alt
        />
        <template v-for="(value, vIndex) in menZm">
          <img :src="setImgZm(value, vIndex)" :class="setclass(vIndex)" alt />
        </template>
      </div>
      <div class="item right">
        <img
          class="bg"
          src="@/assets/imgs/actPosition/normal/men-fm/Path 2@3x.png"
          alt
        />
        <template v-for="(value, vIndex) in menFm">
          <img :src="setImgFm(value, vIndex)" :class="setclassFm(vIndex)" alt />
        </template>
      </div>
    </template>
    <template v-else>
      <div class="item left item-fmen">
        <img
          class="bg"
          src="@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 2@3x.png"
          alt
        />
        <template v-for="(value, vIndex) in fmenZm">
          <img :src="setImgZmF(value, vIndex)" :class="setclassF(vIndex)" alt />
        </template>
      </div>
      <div class="item right item-fmen">
        <img
          class="bg"
          src="@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 2@3x.png"
          alt
        />
        <template v-for="(value, vIndex) in fmenFm">
          <img
            :src="setImgFmF(value, vIndex)"
            :class="setclassFmF(vIndex)"
            alt
          />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'gym-position',
  props: {
    position: {
      type: Array,
      default: function () {
        return []
      }
    },
    // 1 男 2 女
    gender: {
      type: [String, Number],
      default: 2
    }
  },
  data() {
    return {
      // 部位亮哪些号
      positionDataZm: {
        肩部: [2, 3],
        肩关节: [2, 3],
        胸部: [4, 5],
        胸椎: [4, 5],
        手臂: [8, 9],
        腹部: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        核心: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
        腿部: [22, 23],
        大腿后侧: [],
        背部: [],
        后侧: [],
        臀部: [],
        髋部: [],
        全身: [2, 3, 4, 5, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 22, 23]
      },
      positionDataFm: {
        肩部: [2, 3],
        肩关节: [2, 3],
        胸部: [],
        胸椎: [],
        手臂: [6, 7],
        腹部: [],
        核心: [],
        腿部: [18, 19],
        大腿后侧: [18, 19],
        背部: [0, 1, 4, 5, 8, 9, 10, 11],
        后侧: [0, 1, 4, 5, 8, 9, 10, 11],
        臀部: [16, 17],
        髋部: [16, 17],
        全身: [2, 3, 6, 7, 18, 19, 0, 1, 4, 5, 8, 9, 10, 11, 16, 17, 18, 19]
      },
      // 男 正面
      menZm: [
        [
          require('@/assets/imgs/actPosition/normal/men-zm/m-jian-z-2-0.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 3@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/m-jian-z-1-0.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 3 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/m-jian-z-4-0.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 11@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/m-jian-z-3-0.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 11 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 4@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 4@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 4 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 4 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 12@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 12@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 12 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 12 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 13@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 13@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 13 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 13 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 15@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 15@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 15 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 15 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 5@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 5@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 5 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 5 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 6@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 6@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 6 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 6 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 7@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 7@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 7 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 7 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 8@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 8@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 8 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 8 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 9@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 9@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 9 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 9 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 16 Copy 2@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 16 Copy 2@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 16 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 16 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 10@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 10@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 10 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 10 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 17@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 17@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 17 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 17 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 16@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 16@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-zm/Path 16 Copy 3@3x.png'),
          require('@/assets/imgs/actPosition/light/men-zm/light-Path 16 Copy 3@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 14@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 14@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 14 Copy 2@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 14 Copy 2@3x.png')
        ]
      ],
      menFm: [
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 18@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 18@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 18 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 18 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 19@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 19@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 19 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 19 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 20@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 20@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 20 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 20 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 13@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 13@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 13 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 13 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 21@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 21@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 21 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 21 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 22@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 22@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 22 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 22 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 14@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 14@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 14 Copy 2@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 14 Copy 2@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 23@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 23@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 23 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 23 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 24@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 24@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 24 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 24 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 25@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 25@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 25 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 25 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 27@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 27@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 27 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 27 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 28@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 28@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/men-fm/Path 28 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/men-fm/light-Path 28 Copy@3x.png')
        ]
      ],
      fmenZm: [
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 46@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 46@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 46 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 46 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 40@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 40@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 40 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 40 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 4 Copy 2@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 4 Copy 2@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 4 Copy 4@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 4 Copy 4@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 39@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 39@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 39 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 39 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 37@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 37@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 37 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 37 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 36@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 36@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 36 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 36 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 31@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 31@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 31 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 31 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 33@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 33@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 33 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 33 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 34@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 34@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 34 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 34 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 35@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 35@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 35 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 35 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 41@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 41@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 41 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 41 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 42@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 42@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 42 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 42 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 45@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 45@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 45 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 45 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 43@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 43@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 43 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 43 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 44@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 44@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 44 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 44 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 38@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 38@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-zm/fm-Path 38 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-zm/light-fm-Path 38 Copy@3x.png')
        ]
      ],
      fmenFm: [
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 47@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 47@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 47 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 47 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 52@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 52@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 52 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 52 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 53@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 53@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 53 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 53 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 54@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 54@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 54 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 54 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 48 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 48 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 48@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 48@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 49@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 49@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 49 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 49 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 55@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 55@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 55 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 55 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 50@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 50@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 50 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 50 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 51@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 51@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 51 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 51 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 56@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 56@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 56 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 56 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 57@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 57@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 57 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 57 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 58@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 58@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 58 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 58 Copy@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 59@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 59@3x.png')
        ],
        [
          require('@/assets/imgs/actPosition/normal/fmen-fm/fm-f-Path 59 Copy@3x.png'),
          require('@/assets/imgs/actPosition/light/fmen-fm/light-f-fm-Path 59 Copy@3x.png')
        ]
      ]
    }
  },
  methods: {
    setImgFm(value, i) {
      // positionDataFm[item].indexOf(vIndex)!=-1?value[1]:value[0]
      // console.log('value', value, i, this.position.length)
      for (let index = 0; index < this.position.length; index++) {
        const element = this.position[index]
        let temp = this.positionDataFm[element]
        // console.log("element", element, temp, i);
        if (temp.indexOf(i) !== -1) {
          // console.log("element", temp, i);
          return value[1]
        }
      }
      return value[0]
    },
    setImgFmF(value, i) {
      // positionDataFm[item].indexOf(vIndex)!=-1?value[1]:value[0]
      // console.log('value', value, i, this.position.length)
      for (let index = 0; index < this.position.length; index++) {
        const element = this.position[index]
        let temp = this.positionDataFm[element]
        // console.log("element", element, temp, i);
        if (temp.indexOf(i) !== -1) {
          // console.log("element", temp, i);
          return value[1]
        }
      }
      return value[0]
    },
    setImgZm(value, i) {
      // positionDataFm[item].indexOf(vIndex)!=-1?value[1]:value[0]
      // console.log('value', value, i, this.position.length)
      for (let index = 0; index < this.position.length; index++) {
        const element = this.position[index]
        let temp = this.positionDataZm[element]
        // console.log("element", element, temp, i);
        if (temp.indexOf(i) !== -1) {
          // console.log("element", temp, i);
          return value[1]
        }
      }
      return value[0]
    },
    setImgZmF(value, i) {
      // positionDataFm[item].indexOf(vIndex)!=-1?value[1]:value[0]
      // console.log('value', value, i, this.position.length)
      for (let index = 0; index < this.position.length; index++) {
        const element = this.position[index]
        let temp = this.positionDataZm[element]
        // console.log("element", element, temp, i);
        if (temp.indexOf(i) !== -1) {
          // console.log("element", temp, i);
          return value[1]
        }
      }
      return value[0]
    },
    setclass(vIndex) {
      return 'img img-' + vIndex
    },
    setclassF(vIndex) {
      return 'img img-f-' + vIndex
    },
    setclassFm(vIndex) {
      return 'img img-fm-' + vIndex
    },
    setclassFmF(vIndex) {
      return 'img img-fm-f-' + vIndex
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.position {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: vw(15) vw(42);
  box-sizing: border-box;
  .item {
    position: relative;
    width: vw(99.8);
    height: vw(197.2);
    .bg {
      width: vw(99.8);
      height: vw(197.2);
    }
    .img {
      position: absolute;
    }
    .img-1 {
      width: vw(7.2);
      height: vw(4.8);
      position: absolute;
      right: vw(37.3);
      top: vw(28.5);
    }
    .img-0 {
      width: vw(7.2);
      height: vw(4.8);
      position: absolute;
      left: vw(36.8);
      top: vw(28.5);
    }
    .img-3 {
      width: vw(15.2);
      height: vw(13.4);
      right: vw(24.8);
      top: vw(32.5);
    }
    .img-2 {
      width: vw(15.2);
      height: vw(13.4);
      left: vw(25);
      top: vw(32.1);
    }
    .img-4 {
      width: vw(17.7);
      height: vw(17.9);
      left: vw(31.3);
      top: vw(35);
    }
    .img-5 {
      width: vw(17.7);
      height: vw(17.9);
      right: vw(31.3);
      top: vw(35);
    }
    .img-6 {
      width: vw(3.9);
      height: vw(10);
      left: vw(23.2);
      top: vw(39);
    }
    .img-7 {
      width: vw(3.9);
      height: vw(10);
      right: vw(23.1);
      top: vw(39);
    }
    .img-8 {
      width: vw(9.4);
      height: vw(18.9);
      left: vw(21.7);
      top: vw(45.9);
    }
    .img-9 {
      width: vw(9.4);
      height: vw(18.9);
      top: vw(45.9);
      right: vw(21.7);
    }
    .img-10 {
      width: vw(5.9);
      height: vw(29.7);
      left: vw(34.8);
      top: vw(55.7);
    }
    .img-11 {
      width: vw(5.9);
      height: vw(29.7);
      right: vw(34.8);
      top: vw(55.7);
    }
    .img-12 {
      width: vw(8.5);
      height: vw(9);
      left: vw(40.7);
      top: vw(53.4);
    }
    .img-13 {
      width: vw(8.5);
      height: vw(9);
      right: vw(40.7);
      top: vw(53.4);
    }
    .img-14 {
      width: vw(8.4);
      height: vw(8.8);
      left: vw(41.1);
      top: vw(60);
    }
    .img-15 {
      width: vw(8.4);
      height: vw(8.8);
      right: vw(41.1);
      top: vw(60);
    }
    .img-16 {
      width: vw(8.1);
      height: vw(7.3);
      left: vw(41.3);
      top: vw(68.9);
    }
    .img-17 {
      width: vw(8.1);
      height: vw(7.3);
      right: vw(41.3);
      top: vw(68.9);
    }
    .img-18 {
      width: vw(8);
      height: vw(18.6);
      left: vw(41.5);
      top: vw(77);
    }
    .img-19 {
      width: vw(8);
      height: vw(18.6);
      right: vw(41.5);
      top: vw(77);
    }
    .img-20 {
      width: vw(5.8);
      height: vw(7.9);
      left: vw(38.4);
      top: vw(90.2);
    }
    .img-21 {
      width: vw(5.8);
      height: vw(7.9);
      right: vw(38.4);
      top: vw(90.2);
    }
    .img-22 {
      width: vw(13);
      height: vw(37.4);
      left: vw(31.4);
      top: vw(91.7);
    }
    .img-23 {
      width: vw(13);
      height: vw(37.4);
      right: vw(31.3);
      top: vw(91.7);
    }
    .img-24 {
      width: vw(5.1);
      height: vw(18.4);
      left: vw(42.1);
      top: vw(100);
    }
    .img-25 {
      width: vw(5.1);
      height: vw(18.4);
      right: vw(42.1);
      top: vw(100);
    }
    .img-26 {
      width: vw(7.9);
      height: vw(34);
      left: vw(32.1);
      top: vw(143.1);
    }
    .img-27 {
      width: vw(7.9);
      height: vw(34);
      right: vw(32.1);
      top: vw(143.1);
    }
    .img-28 {
      width: vw(3);
      height: vw(17.5);
      left: vw(40.7);
      top: vw(150);
    }
    .img-29 {
      width: vw(3);
      height: vw(17.5);
      right: vw(40.7);
      top: vw(150);
    }
    .img-30 {
      width: vw(10.7);
      height: vw(23.3);
      left: vw(14);
      top: vw(64.8);
    }
    .img-31 {
      width: vw(10.7);
      height: vw(23.3);
      right: vw(14);
      top: vw(64.8);
    }
    .img-fm-0 {
      width: vw(13.1);
      height: vw(35.3);
      left: vw(36.4);
      top: vw(24);
    }
    .img-fm-1 {
      width: vw(13.1);
      height: vw(36.3);
      right: vw(36.1);
      top: vw(24);
    }
    .img-fm-2 {
      width: vw(12.5);
      height: vw(15.5);
      left: vw(23.3);
      top: vw(32.2);
    }
    .img-fm-3 {
      width: vw(12.5);
      height: vw(15.5);
      right: vw(23.3);
      top: vw(32.2);
    }
    .img-fm-4 {
      width: vw(9.4);
      height: vw(12.1);
      left: vw(30);
      top: vw(37.2);
    }
    .img-fm-5 {
      width: vw(9.4);
      height: vw(12.1);
      right: vw(30);
      top: vw(37);
    }
    .img-fm-6 {
      width: vw(8.8);
      height: vw(20.2);
      left: vw(21.5);
      top: vw(46.7);
    }
    .img-fm-7 {
      width: vw(8.8);
      height: vw(20.2);
      right: vw(21.5);
      top: vw(46.7);
    }
    .img-fm-8 {
      width: vw(14.5);
      height: vw(29.6);
      left: vw(32.1);
      top: vw(49.2);
    }
    .img-fm-9 {
      width: vw(14.5);
      height: vw(29.6);
      right: vw(32.1);
      top: vw(49.2);
    }
    .img-fm-10 {
      width: vw(9.6);
      height: vw(25.2);
      left: vw(39.6);
      top: vw(61.6);
    }
    .img-fm-11 {
      width: vw(9.6);
      height: vw(25.2);
      right: vw(39.6);
      top: vw(61.6);
    }
    .img-fm-12 {
      width: vw(10.7);
      height: vw(23.3);
      left: vw(14);
      top: vw(64.8);
    }
    .img-fm-13 {
      width: vw(10.7);
      height: vw(23.3);
      right: vw(14);
      top: vw(64.8);
    }
    .img-fm-14 {
      width: vw(11.5);
      height: vw(10.1);
      left: vw(32.5);
      top: vw(81.7);
    }
    .img-fm-15 {
      width: vw(11.5);
      height: vw(10.1);
      right: vw(32.5);
      top: vw(81.7);
    }
    .img-fm-16 {
      width: vw(16.2);
      height: vw(20.2);
      left: vw(32.3);
      top: vw(85.4);
    }
    .img-fm-17 {
      width: vw(16.2);
      height: vw(20.2);
      right: vw(32.3);
      top: vw(85.4);
    }
    .img-fm-18 {
      width: vw(11);
      height: vw(26.3);
      left: vw(31.9);
      top: vw(106.5);
    }
    .img-fm-19 {
      width: vw(11);
      height: vw(26.3);
      right: vw(31.9);
      top: vw(106.5);
    }
    .img-fm-20 {
      width: vw(5.9);
      height: vw(24.6);
      left: vw(32.7);
      top: vw(142.3);
    }
    .img-fm-21 {
      width: vw(5.9);
      height: vw(24.6);
      right: vw(32.7);
      top: vw(142.3);
    }
    .img-fm-22 {
      width: vw(6);
      height: vw(23);
      left: vw(38.6);
      top: vw(146.7);
    }
    .img-fm-23 {
      width: vw(6);
      height: vw(23);
      right: vw(38.6);
      top: vw(146.7);
    }
  }
  .item-fmen {
    width: vw(92);
    height: vw(197);
    .bg {
      width: vw(92);
      height: vw(197);
    }
    .img-f-0 {
      width: vw(5);
      height: vw(6);
      left: vw(36);
      top: vw(26);
    }
    .img-f-1 {
      width: vw(5);
      height: vw(6);
      right: vw(36);
      top: vw(26);
    }
    .img-f-2 {
      width: vw(8);
      height: vw(9);
      left: vw(25);
      top: vw(30);
    }
    .img-f-3 {
      width: vw(8);
      height: vw(9);
      right: vw(25);
      top: vw(30);
    }
    .img-f-4 {
      width: vw(13);
      height: vw(16);
      left: vw(33);
      top: vw(35);
    }
    .img-f-5 {
      width: vw(13);
      height: vw(16);
      right: vw(33);
      top: vw(35);
    }
    .img-f-6 {
      width: vw(8);
      height: vw(11);
      left: vw(27);
      top: vw(31);
    }
    .img-f-7 {
      width: vw(8);
      height: vw(11);
      right: vw(27);
      top: vw(31);
    }
    .img-f-8 {
      width: vw(7);
      height: vw(14);
      left: vw(24);
      top: vw(44);
    }
    .img-f-9 {
      width: vw(7);
      height: vw(14);
      right: vw(24);
      top: vw(44);
    }
    .img-f-10 {
      width: vw(3);
      height: vw(22);
      left: vw(36);
      top: vw(56);
    }
    .img-f-11 {
      width: vw(4);
      height: vw(22);
      right: vw(34);
      top: vw(56);
    }
    .img-f-12 {
      width: vw(6);
      height: vw(6);
      left: vw(40);
      top: vw(52);
    }
    .img-f-13 {
      width: vw(7);
      height: vw(6);
      right: vw(38);
      top: vw(52);
    }
    .img-f-14 {
      width: vw(6);
      height: vw(6);
      left: vw(40);
      top: vw(57);
    }
    .img-f-15 {
      width: vw(7);
      height: vw(6);
      right: vw(38);
      top: vw(57);
    }
    .img-f-16 {
      width: vw(6);
      height: vw(6);
      left: vw(40);
      top: vw(63);
    }
    .img-f-17 {
      width: vw(6);
      height: vw(6);
      right: vw(38);
      top: vw(63);
    }
    .img-f-18 {
      width: vw(7);
      height: vw(18);
      left: vw(40);
      top: vw(69);
    }
    .img-f-19 {
      width: vw(7);
      height: vw(18);
      right: vw(38);
      top: vw(69);
    }
    .img-f-20 {
      width: vw(8);
      height: vw(15);
      left: vw(35);
      top: vw(78);
    }
    .img-f-21 {
      width: vw(8);
      height: vw(15);
      right: vw(33);
      top: vw(78);
    }
    .img-f-22 {
      width: vw(11);
      height: vw(48);
      left: vw(30);
      top: vw(80);
    }
    .img-f-23 {
      width: vw(11);
      height: vw(48);
      right: vw(29);
      top: vw(81);
    }
    .img-f-24 {
      width: vw(5);
      height: vw(16);
      left: vw(38.5);
      top: vw(94);
    }
    .img-f-25 {
      width: vw(5);
      height: vw(16);
      right: vw(38);
      top: vw(94);
    }
    .img-f-26 {
      width: vw(6);
      height: vw(30);
      left: vw(34);
      top: vw(143);
    }
    .img-f-27 {
      width: vw(5);
      height: vw(30);
      right: vw(34);
      top: vw(144);
    }
    .img-f-28 {
      width: vw(4);
      height: vw(24);
      left: vw(40);
      top: vw(145);
    }
    .img-f-29 {
      width: vw(3);
      height: vw(24);
      right: vw(40);
      top: vw(145);
    }
    .img-f-30 {
      width: vw(11);
      height: vw(19);
      left: vw(16);
      top: vw(59);
    }
    .img-f-31 {
      width: vw(11);
      height: vw(19);
      right: vw(15);
      top: vw(60);
    }
    .img-fm-f-0 {
      width: vw(13);
      height: vw(26);
      left: vw(32);
      top: vw(23);
    }
    .img-fm-f-1 {
      width: vw(13);
      height: vw(26);
      right: vw(32);
      top: vw(23);
    }
    .img-fm-f-2 {
      width: vw(8);
      height: vw(11);
      left: vw(25);
      top: vw(32);
    }
    .img-fm-f-3 {
      width: vw(8);
      height: vw(11);
      right: vw(25);
      top: vw(32);
    }
    .img-fm-f-4 {
      width: vw(7);
      height: vw(7);
      left: vw(30);
      top: vw(36);
    }
    .img-fm-f-5 {
      width: vw(7);
      height: vw(7);
      right: vw(30);
      top: vw(36);
    }
    .img-fm-f-6 {
      width: vw(7);
      height: vw(18);
      left: vw(23);
      top: vw(42);
    }
    .img-fm-f-7 {
      width: vw(7);
      height: vw(17);
      right: vw(23);
      top: vw(43);
    }
    .img-fm-f-8 {
      width: vw(14);
      height: vw(23);
      left: vw(32);
      top: vw(44);
    }
    .img-fm-f-9 {
      width: vw(13);
      height: vw(23);
      right: vw(32);
      top: vw(44);
    }
    .img-fm-f-10 {
      width: vw(7);
      height: vw(15);
      left: vw(38);
      top: vw(63);
    }
    .img-fm-f-11 {
      width: vw(7);
      height: vw(15);
      right: vw(38);
      top: vw(63);
    }
    .img-fm-f-12 {
      width: vw(13);
      height: vw(18);
      left: vw(14.5);
      top: vw(62);
    }
    .img-fm-f-13 {
      width: vw(13);
      height: vw(18);
      right: vw(13);
      top: vw(64);
    }
    .img-fm-f-14 {
      width: vw(11);
      height: vw(11);
      left: vw(31);
      top: vw(76);
    }
    .img-fm-f-15 {
      width: vw(10);
      height: vw(12);
      right: vw(31);
      top: vw(75);
    }
    .img-fm-f-16 {
      width: vw(16);
      height: vw(21);
      left: vw(29);
      top: vw(81);
    }
    .img-fm-f-17 {
      width: vw(16);
      height: vw(21);
      right: vw(28);
      top: vw(81);
    }
    .img-fm-f-18 {
      width: vw(12);
      height: vw(29);
      left: vw(30);
      top: vw(105);
    }
    .img-fm-f-19 {
      width: vw(12);
      height: vw(29);
      right: vw(30);
      top: vw(105);
    }
    .img-fm-f-20 {
      width: vw(4);
      height: vw(18);
      left: vw(40);
      top: vw(101);
    }
    .img-fm-f-21 {
      width: vw(4);
      height: vw(18);
      right: vw(39);
      top: vw(101);
    }
    .img-fm-f-22 {
      width: vw(5);
      height: vw(25);
      left: vw(34);
      top: vw(143);
    }
    .img-fm-f-23 {
      width: vw(5);
      height: vw(25);
      right: vw(33);
      top: vw(143);
    }
    .img-fm-f-24 {
      width: vw(4);
      height: vw(26);
      left: vw(39);
      top: vw(137);
    }
    .img-fm-f-25 {
      width: vw(5);
      height: vw(26);
      right: vw(38);
      top: vw(137);
    }
  }
}
</style>
